import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 14, showValue = false, count }) {
  const rounded = Math.round(value * 2) / 2;
  const stars = [1, 2, 3, 4, 5].map((i) => {
    const filled = i <= Math.floor(rounded);
    const half = !filled && i - 0.5 === rounded;
    return (
      <span key={i} className="relative inline-flex" aria-hidden="true">
        <Star
          className="text-neutral-300"
          style={{ width: size, height: size }}
          strokeWidth={1.5}
        />
        {(filled || half) && (
          <Star
            className="absolute inset-0 text-neutral-900 fill-neutral-900"
            style={{
              width: size,
              height: size,
              clipPath: half ? "inset(0 50% 0 0)" : undefined,
            }}
            strokeWidth={1.5}
          />
        )}
      </span>
    );
  });
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="star-rating">
      <span className="inline-flex items-center gap-0.5">{stars}</span>
      {showValue && (
        <span className="text-xs text-neutral-600 font-medium">
          {Number(value).toFixed(1)}
          {typeof count === "number" && (
            <span className="text-neutral-400"> · {count.toLocaleString()}</span>
          )}
        </span>
      )}
    </span>
  );
}
